export const FEATURE_NAMES = {
    USE_NEW_LLEG_DIGITAL_APPLICATION: 'USE_NEW_LLEG_DIGITAL_APPLICATION',
    USE_NEW_LLEG_PAPER_APPLICATION: 'USE_NEW_LLEG_PAPER_APPLICATION',
    VIEW_LLEG_APPLICATION: 'VIEW_LLEG_APPLICATION',
};
